<template>
  <div class="resetPassword">
    <el-main>
      <el-row class="nofull">
        <el-main>
          <el-row style="width: 360px; margin: 30px auto">
            <img class="logo" src="../assets/logo_new.png" />
            <div class="site_name">{{ siteName }}</div>
          </el-row>
          <el-row style="width: 360px; margin: 0 auto">
            <i class="el-icon-success big"></i>
            <p style="margin-bottom: 20px">密码修改成功</p>

            <p style="text-align: left; font-size: 15px"></p>
            <el-button
              type="primary"
              style="width: 100%"
              @click="handleSetNewPassword"
              >登录</el-button
            >
          </el-row>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'ResetPasswordEmailSend',
  props: {
    siteName: String,
  },
  mounted() {
    this.$emit('activeIndex', '');
    this.$emit('pageClass', 'userCenter');
  },
  data() {
    return {};
  },
  // 接通后删除
  methods: {
    handleSetNewPassword() {
      this.$router.replace('/');
      this.$store.commit('blOpenLoginBox', true);
    },
  },
};
</script>

<style scoped></style>
